"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApplicationName = void 0;
var ApplicationName;

(function (ApplicationName) {
  ApplicationName["InstaQuote"] = "insta-quote";
  ApplicationName["DotCom"] = "dot-com";
  ApplicationName["Raptor"] = "raptor";
  ApplicationName["QueueManagement"] = "queue-management";
})(ApplicationName || (exports.ApplicationName = ApplicationName = {}));